import Parse from 'parse';
import store from '../store'

export const ParseAuthService = {
    setMasterKey: () => {
        return Parse.masterKey = store.state.masterKey;
    },
    hasMasterKey: () => {
        return store.state.masterKey != null;
    },

    hasUser: () => {
        return Parse.User.current();
    },

    logIn({username, password, masterKey, admin}) {
        Parse.masterKey = admin ? masterKey : null;
        return Parse.User.logIn(username, password, {useMasterKey: admin}).then(x => {
                if (admin) {
                    store.commit("MASTER_KEY", masterKey);
                }
                return x;
            }
        );
    },

    logOut() {
        return Parse.User.logOut().then((user) => {
            store.commit("MASTER_KEY", null);
            return user;
        });
    },

    signUp({username, email, password, masterKey, admin}) {
        var user = new Parse.User();
        user.setEmail(email);
        user.setPassword(password);
        user.setUsername(username);
        Parse.masterKey = admin ? masterKey : null;

        return user.signUp(null, {useMasterKey: admin}).then(u => {
            if (admin) {
                store.commit("MASTER_KEY", masterKey);
            }
            new Parse.Query(Parse.Role).equalTo("name", "Admin").first({useMasterKey: admin}).then(role => {
                role.getUsers().add(u);
                const acl = role.getACL();
                acl.setReadAccess(u, true);
                acl.setWriteAccess(u, true);
                role.setACL(acl,null);
                role.save(null, {useMasterKey: admin}).then(ro => console.log(ro)).catch(e => console.log(e));
            });
            return u;
        }).catch(e => {
            console.log(e);
            throw new Error(e);
        })
    }
}